import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { AuthenticationService } from '../../_services';
import { Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-last-posts',
  templateUrl: './last-posts.component.html',
  styleUrls: ['./last-posts.component.css']
})
export class LastPostsComponent implements OnInit {
  lastPosts: any[];
  posts = [];
  latePosts = false;
  time: any;
  public i = 0;
  html: any;
  html2 = '';
  postKey: any;
  html3 = '';
  username = '';
  firstname = '';
  username2 = '';
  firstname2 = '';
  username3 = '';
  firstname3 = '';
  profileImage: any;
  profileImage2: any;
  profileImage3: any;
  routerUsername: any;
  text: any;
  subs = new Subscription();
  isCollapsable: boolean;
  constructor(
    private authenticationService: AuthenticationService,
    private afs: AngularFirestore,
    private router: Router) {
    this.authenticationService.logout();
    this.subs = this.afs.collection('posts', ref => ref.orderBy('order').limit(50)).snapshotChanges().pipe(map(actions => {
      return actions.map(snap => {
        return {
          id: snap.payload.doc.id,
          ...snap.payload.doc.data()
        }
      })

    })).subscribe(data => {
      this.lastPosts = data.slice(0, 16);

    })


  }
  ngOnInit() {
    this.start();

  }
  ngOnDestroy() {
    this.hover();
    this.subs.unsubscribe();

  }
  hover() {
    clearInterval(this.time);
  }
  stopPosts() {


    this.hover();
    const x = setInterval(() => {
      let length = this.lastPosts.length;
      this.i++;
      if (this.i === length) {
        this.i = 0;
      }
      let cards = document.querySelectorAll('.card');
      let holder = document.querySelectorAll('.container2')[0]
      let preActiveCard = cards[1];
      let nextActiveCard = cards[2];
      holder.classList.remove('next');
      holder.classList.remove('reset');
      holder.classList.add('next');
      if (this.i < 15) {


        this.isCollapsable = false;
        this.profileImage = this.lastPosts[(this.i) + 1].author.profileImage;
        this.html = this.lastPosts[(this.i) + 1].innerText;
        this.postKey = this.lastPosts[(this.i) + 1].id;


        this.routerUsername = this.lastPosts[(this.i) + 1].author.username;

        this.username = '@' + this.lastPosts[(this.i) + 1].author.username;
        this.firstname = this.lastPosts[(this.i) + 1].author.firstname + ' ' + this.lastPosts[(this.i) + 1].author.lastname;
        var uniquename = this.html.split(" ").filter(s => s.indexOf("@") !== -1);
        if (uniquename[0])
          this.html = this.html.replace(uniquename[0], "<a href='" + uniquename[0].substring(1, uniquename[0].length) + "'>" + uniquename[0] + "</a>");
        if (uniquename[1])
          this.html = this.html.replace(uniquename[1], "<a href='" + uniquename[1].substring(1, uniquename[1].length) + "'>" + uniquename[1] + "</a>");
        if (uniquename[2])
          this.html = this.html.replace(uniquename[2], "<a href='" + uniquename[2].substring(1, uniquename[2].length) + "'>" + uniquename[2] + "</a>");
        if (uniquename[3])
          this.html = this.html.replace(uniquename[3], "<a href='" + uniquename[3].substring(1, uniquename[3].length) + "'>" + uniquename[3] + "</a>");

        var hashtag = this.html.split(" ").filter(a => a.indexOf("#") !== -1);
        if (hashtag[0])
          this.html = this.html.replace(hashtag[0], "");
        if (hashtag[1])
          this.html = this.html.replace(hashtag[1], "");
        if (hashtag[2])
          this.html = this.html.replace(hashtag[2], "");
        if (hashtag[3])
          this.html = this.html.replace(hashtag[3], "");
        if (hashtag[4])
          this.html = this.html.replace(hashtag[4], "");
        if (this.html.length > 250) {

          this.html = this.html.substring(0, 250);
          this.isCollapsable = true;
        }
        this.isCollapsable = false;
      }


      if (this.i < 14) {
        this.profileImage2 = this.lastPosts[(this.i) + 2].author.profileImage;
        this.html2 = this.lastPosts[(this.i) + 2].innerText;
        this.username2 = this.lastPosts[(this.i) + 2].author.username;
        this.firstname2 = this.lastPosts[(this.i) + 2].author.firstname + ' ' + this.lastPosts[(this.i) + 2].author.lastname;
        if (this.html2.length > 200) {

          this.html2 = this.html2.substring(0, 200);
          this.isCollapsable = true;
        }

      }
      if (this.i === 14) {
        this.profileImage2 = this.lastPosts[0].author.profileImage;
        this.html2 = this.lastPosts[0].innerText;
        this.username2 = this.lastPosts[0].author.username;
        this.firstname2 = this.lastPosts[0].author.firstname + ' ' + this.lastPosts[0].author.lastname;
        if (this.html2.length > 200) {

          this.html2 = this.html2.substring(0, 200);
          this.isCollapsable = true;
        }

      }
      if (this.i === 15) {
        this.profileImage = this.lastPosts[0].author.profileImage;
        this.html = this.lastPosts[0].innerText;
        this.postKey = this.lastPosts[0].id;
        this.username = this.lastPosts[0].author.username;
        this.firstname = this.lastPosts[0].author.firstname + ' ' + this.lastPosts[0].author.lastname;
        if (this.html.length > 250) {

          this.html = this.html.substring(0, 250);
          this.isCollapsable = true;
        }
        this.isCollapsable = false;
        this.profileImage2 = this.lastPosts[1].author.profileImage;
        this.html2 = this.lastPosts[1].innerText;
        this.username2 = this.lastPosts[1].author.username;
        this.firstname2 = this.lastPosts[1].author.firstname + ' ' + this.lastPosts[1].author.lastname;
        if (this.html2.length > 200) {

          this.html2 = this.html2.substring(0, 200);
          this.isCollapsable = true;
        }
      }

      this.html3 = this.lastPosts[(this.i)].innerText;
      if (this.html3.length > 200) {

        this.html3 = this.html3.substring(0, 200);
        this.isCollapsable = true;
      }


      this.profileImage3 = this.lastPosts[(this.i)].author.profileImage;
      this.username3 = this.lastPosts[(this.i)].author.username;
      this.firstname3 = this.lastPosts[(this.i)].author.firstname + ' ' + this.lastPosts[this.i].author.lastname;

      preActiveCard.classList.remove('active');
      nextActiveCard.classList.add('active');
      setTimeout(() => {
        holder.classList.remove('next');
        holder.classList.add('reset');
        preActiveCard.classList.add('active');
        nextActiveCard.classList.remove('active');

        clearInterval(x);
      }, 500);
    }, 600);
  }
  start() {
    if (this.router.url === '/') {
      this.time = setInterval(() => {
        this.latePosts = true;
        if (this.lastPosts) {
          let length = this.lastPosts.length;
          this.i++;
          if (this.i === length) {
            this.i = 0;
          }

          let cards = document.querySelectorAll('.card');
          let holder = document.querySelectorAll('.container2')[0]
          let preActiveCard = cards[1];
          let nextActiveCard = cards[2];
          holder.classList.remove('next');
          holder.classList.remove('reset');
          holder.classList.add('next');
          if (this.i < 15) {

            this.isCollapsable = false;

            this.profileImage = this.lastPosts[(this.i) + 1].author.profileImage;
            this.html = this.lastPosts[(this.i) + 1].innerText;
            this.postKey = this.lastPosts[(this.i) + 1].id;

            this.routerUsername = this.lastPosts[(this.i) + 1].author.username;

            this.username = '@' + this.lastPosts[(this.i) + 1].author.username;
            this.firstname = this.lastPosts[(this.i) + 1].author.firstname + ' ' + this.lastPosts[(this.i) + 1].author.lastname;
            var uniquename = this.html.split(" ").filter(s => s.indexOf("@") !== -1);
            if (uniquename[0])
              this.html = this.html.replace(uniquename[0], "<a href='" + uniquename[0].substring(1, uniquename[0].length) + "'>" + uniquename[0] + "</a>");
            if (uniquename[1])
              this.html = this.html.replace(uniquename[1], "<a href='" + uniquename[1].substring(1, uniquename[1].length) + "'>" + uniquename[1] + "</a>");
            if (uniquename[2])
              this.html = this.html.replace(uniquename[2], "<a href='" + uniquename[2].substring(1, uniquename[2].length) + "'>" + uniquename[2] + "</a>");
            if (uniquename[3])
              this.html = this.html.replace(uniquename[3], "<a href='" + uniquename[3].substring(1, uniquename[3].length) + "'>" + uniquename[3] + "</a>");

            var hashtag = this.html.split(" ").filter(a => a.indexOf("#") !== -1);
            if (hashtag[0])
              this.html = this.html.replace(hashtag[0], "");
            if (hashtag[1])
              this.html = this.html.replace(hashtag[1], "");
            if (hashtag[2])
              this.html = this.html.replace(hashtag[2], "");
            if (hashtag[3])
              this.html = this.html.replace(hashtag[3], "");
            if (hashtag[4])
              this.html = this.html.replace(hashtag[4], "");

            if (this.html.length > 250) {
              this.isCollapsable = true;

              this.html = this.html.substring(0, 250);

            }


          }


          if (this.i < 14) {

            this.profileImage2 = this.lastPosts[(this.i) + 2].author.profileImage;
            this.html2 = this.lastPosts[(this.i) + 2].innerText;
            this.username2 = this.lastPosts[(this.i) + 2].author.username;
            this.firstname2 = this.lastPosts[(this.i) + 2].author.firstname + ' ' + this.lastPosts[(this.i) + 2].author.lastname;
            if (this.html2.length > 200) {

              this.html2 = this.html2.substring(0, 200);
              this.isCollapsable = true;
            }





          }
          if (this.i === 14) {


            this.profileImage2 = this.lastPosts[0].author.profileImage;
            this.html2 = this.lastPosts[0].innerText;
            if (this.html2.length > 200) {

              this.html2 = this.html2.substring(0, 200);
              this.isCollapsable = true;
            }
            this.username2 = this.lastPosts[0].author.username;
            this.firstname2 = this.lastPosts[0].author.firstname + ' ' + this.lastPosts[0].author.lastname;





          }
          if (this.i === 15) {


            this.profileImage = this.lastPosts[0].author.profileImage;
            this.html = this.lastPosts[0].innerText;
            this.postKey = this.lastPosts[0].id;
            if (this.html.length > 250) {

              this.isCollapsable = true;

              this.html = this.html.substring(0, 250);

            }

            this.username = this.lastPosts[0].author.username;
            this.firstname = this.lastPosts[0].author.firstname + ' ' + this.lastPosts[0].author.lastname;
            var uniquename = this.html.split(" ").filter(s => s.indexOf("@") !== -1);
            if (uniquename[0])
              this.html = this.html.replace(uniquename[0], "<a href='" + uniquename[0].substring(1, uniquename[0].length) + "'>" + uniquename[0] + "</a>");
            if (uniquename[1])
              this.html = this.html.replace(uniquename[1], "<a href='" + uniquename[1].substring(1, uniquename[1].length) + "'>" + uniquename[1] + "</a>");
            if (uniquename[2])
              this.html = this.html.replace(uniquename[2], "<a href='" + uniquename[2].substring(1, uniquename[2].length) + "'>" + uniquename[2] + "</a>");
            if (uniquename[3])
              this.html = this.html.replace(uniquename[3], "<a href='" + uniquename[3].substring(1, uniquename[3].length) + "'>" + uniquename[3] + "</a>");

            var hashtag = this.html.split(" ").filter(a => a.indexOf("#") !== -1);
            if (hashtag[0])
              this.html = this.html.replace(hashtag[0], "");
            if (hashtag[1])
              this.html = this.html.replace(hashtag[1], "");
            if (hashtag[2])
              this.html = this.html.replace(hashtag[2], "");
            if (hashtag[3])
              this.html = this.html.replace(hashtag[3], "");
            if (hashtag[4])
              this.html = this.html.replace(hashtag[4], "");

            this.profileImage2 = this.lastPosts[1].author.profileImage;
            this.html2 = this.lastPosts[1].innerText;
            this.username2 = this.lastPosts[1].author.username;
            this.firstname2 = this.lastPosts[1].author.firstname + ' ' + this.lastPosts[1].author.lastname;
            if (this.html2.length > 200) {
              this.isCollapsable = true;

              this.html2 = this.html2.substring(0, 200);

            }




          }
          this.html3 = this.lastPosts[(this.i)].innerText;
          if (this.html3.length > 200) {

            this.html3 = this.html3.substring(0, 200);
            this.isCollapsable = true;
          }



          this.profileImage3 = this.lastPosts[(this.i)].author.profileImage;
          this.username3 = this.lastPosts[(this.i)].author.username;
          this.firstname3 = this.lastPosts[(this.i)].author.firstname + ' ' + this.lastPosts[this.i].author.lastname;

          preActiveCard.classList.remove('active');
          nextActiveCard.classList.add('active');
          setTimeout(() => {
            holder.classList.remove('next');
            holder.classList.add('reset');
            preActiveCard.classList.add('active');
            nextActiveCard.classList.remove('active');
          }, 600);
        }

      }, 3000);


    }

  }
  readMore() {
    this.router.navigate(['/auth']);
  }
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/last-posts/last-posts.component.ts